import { 
	LinkExpirationMeaning, 
	PermissionType
} from 'phoenix/domain';
import { DateService } from 'phoenix/services'
import { ProgressService } from 'phoenix/services';
import { ShaasFolderShare } from 'sharebase/domain';
import {
	IFolderService,
	ToastService
} from 'sharebase/services';
import { CommonUtilsService } from 'util/util';
import * as moment from 'moment';

require('./configure-share.styles');
const template = require('./configure-share.template');
const DEFAULT_EXPIRATON_DAYS = 30;

class ConfigureShareController implements ng.IComponentController {
	private shareId:number;

	public configureShareForm: ng.IFormController;
	public readonly defaultExpirationMeaning = LinkExpirationMeaning.Days;
	public defaultExpirationValue = DEFAULT_EXPIRATON_DAYS;
	public expirationPhrase:string;
	public folderShare = new ShaasFolderShare();
	public formWasSubmitted = false;
	public isPanelOpen = false;
	public maxExpirationDate:Date;
	public maxExpirationDays:number;

	public static $inject = [
		'$mdConstant',
		'$window',
		'dateFilter',
		'pxDateService',
		'pxProgressService',
		'sbFolderService',
		'sbToastService',
		'utils',
		'gettextCatalog'
	];

	constructor(
		private readonly $mdConstant,
		private readonly $window:ng.IWindowService,
		private readonly dateFilter: ng.IFilterDate,
		private readonly pxDateService:DateService,
		private readonly pxProgressService: ProgressService,
		private readonly sbFolderService:IFolderService,
		private readonly sbToastService:ToastService,
		utils: CommonUtilsService,
		private readonly gettextCatalog:ng.gettext.gettextCatalog
	) {
		let pickerSettings = this.sbFolderService.getLinkRights(PermissionType.NONE)
			.then(rr => utils.propsToCamel(rr))
			.then(rights => {
				const hasMaxExpirationDays = rights.maxLinkExpirationDays > 0;

				this.defaultExpirationValue = !hasMaxExpirationDays ? DEFAULT_EXPIRATON_DAYS :
					Math.min(rights.maxLinkExpirationDays, DEFAULT_EXPIRATON_DAYS);
				
				this.folderShare.dateExpires = this.pxDateService.getRelativeDate(this.defaultExpirationMeaning, this.defaultExpirationValue);
				this.maxExpirationDays = rights.maxLinkExpirationDays;
				this.maxExpirationDate = rights.maxLinkExpirationDays ? moment().add(rights.maxLinkExpirationDays, 'days').toDate() : null;

				this.setExpirationPhrase(this.defaultExpirationMeaning);
			});
		this.pxProgressService.enqueue(pickerSettings);
	}

	public get permissionsPhrase(){
		if(this.folderShare.preventDownload){
			return this.gettextCatalog.getString('Users will be able to view the items in the folder.');
			
		} else {
			return this.gettextCatalog.getString('Users will be able to view and download the items in the folder.');
		}
	}

	public closeWindow() {
		this.$window.close();
	}

	public onExpirationDateChanged(updatedDate:Date, expirationMeaning:LinkExpirationMeaning) {
		this.folderShare.dateExpires = updatedDate;
		this.setExpirationPhrase(expirationMeaning);
	}

	public saveShareSettings() {
		if(!this.configureShareForm.$valid) {
			return;
		}

		this.pxProgressService.backdrop = true;
		let p = this.sbFolderService.updateShaasFolderShare(this.shareId, this.folderShare.getPatchCommands())
			.then(response => {
				this.formWasSubmitted = true;
			})
			.catch(error => {
				this.sbToastService.showSimple(this.gettextCatalog.getString('The share could not be updated'));
			})
			.finally(()=> this.pxProgressService.backdrop = false);
		this.pxProgressService.enqueue(p);
	}

	public validateEmail(email: string) {
		//#TODO move this expression to a more centralized place
		var emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
		if(!emailRegex.test(email)) {
			this.sbToastService.showSimple(this.gettextCatalog.getString('{{email}} is an invalid email address.', { email: email }));
			return null;
		}

		return email;
	}

	public togglePanel(){
		this.isPanelOpen = !this.isPanelOpen;
	}

	public readonly emailChipSeparators = [
		this.$mdConstant.KEY_CODE.COMMA, 
		this.$mdConstant.KEY_CODE.SEMICOLON, 
		this.$mdConstant.KEY_CODE.ENTER, 
		this.$mdConstant.KEY_CODE.SPACE
	];

	public get isWindowCloseable(){
		// window.close() only works for windows opened by the script
		return this.$window.opener != null;
	}

	private setExpirationPhrase(expirationMeaning:LinkExpirationMeaning) {
		if(expirationMeaning === LinkExpirationMeaning.Never || expirationMeaning === LinkExpirationMeaning.SingleUse) {
			this.expirationPhrase = '';
		}
		else {
			this.expirationPhrase = this.gettextCatalog.getString('Their access will be revoked after {{ date }}.', { date: this.dateFilter(this.folderShare.dateExpires, 'short') });
		}
	}
}

export const ConfigureShareComponent:ng.IComponentOptions = {
	template,
	controller: ConfigureShareController,
	controllerAs: 'vm',
	bindings: {
		shareId: '<'
	}
}


// WEBPACK FOOTER //
// ./src/shaas/components/configure-share/configure-share.ts